module.exports = __webpack_public_path__ + "static/media/filter-black.7e33b69f.svg";